import webSocketSlice from './slice';

const websocketReducer = webSocketSlice.reducer;

export default websocketReducer;
